import { Modal } from "../../../components/common/Modal";
import React from "react";

type DeleteClientModalProps = {
  isOpen: boolean;
  clientName: string;
  pending: boolean;
  errorMessage?: string | null;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteClientModal: React.FC<DeleteClientModalProps> = ({
  isOpen,
  clientName,
  pending,
  errorMessage,
  onClose,
  onConfirm,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Удалить клиента?"
    text=""
    actionButtonText={null}
    actionButtonCallback={undefined}
    actionButtonPending={false}
    cancelButtonText={null}
  >
    <div className="space-y-4">
      <p className="text-sm text-gray-600">
        Клиент «{clientName || "Без имени"}» будет удалён из базы. Это действие
        нельзя отменить.
      </p>

      {errorMessage && (
        <div
          className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700"
          role="alert"
        >
          {errorMessage}
        </div>
      )}

      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          disabled={pending}
          onClick={onConfirm}
          className="inline-flex min-w-[84px] items-center justify-center rounded-md bg-red-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-gray-400"
        >
          {pending ? "Удаляем…" : "Удалить"}
        </button>
        <button
          type="button"
          disabled={pending}
          onClick={onClose}
          className="inline-flex min-w-[84px] items-center justify-center rounded-md border border-[#c06198] px-5 py-2.5 text-sm font-medium text-[#c06198] transition-colors hover:bg-[#c06198]/10 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Отмена
        </button>
      </div>
    </div>
  </Modal>
);
